import {
  getPathnameFromUrl,
  removeStartingProtocol,
} from '../../../utils/locationUtils';

const isHostMatch = (link, windowHost) => {
  const linkWithoutProtocol = removeStartingProtocol(link);
  const [linkHost] = linkWithoutProtocol.split('/');
  return linkHost === windowHost || `www.${linkHost}` === windowHost;
};

const isPathnameMatchWithRouterBasename = (linkPathname, store) => {
  return `${linkPathname}/`.startsWith(`${store.storePath}/`);
};

const getPathnameMatchLength = (linkPathname, currentLocationPathname) => {
  const array = [linkPathname, currentLocationPathname].concat().sort();
  const [word1, word2] = array;
  const length = word1.length;
  let i = 0;
  while (i < length && word1.charAt(i) === word2.charAt(i)) {
    i++;
  }
  return i;
};

const findActiveLink = (links, currentLocationPathname, host, store) => {
  let active = '';
  let shortestMatch = 0;
  links.forEach(({ url }) => {
    const linkPathname = getPathnameFromUrl(url);
    if (
      isPathnameMatchWithRouterBasename(linkPathname, store) &&
      isHostMatch(url, host)
    ) {
      const matchLength = getPathnameMatchLength(
        linkPathname,
        currentLocationPathname,
      );
      if (matchLength > 0) {
        if (shortestMatch === 0) {
          active = url;
          shortestMatch = matchLength;
        } else if (matchLength < shortestMatch) {
          active = url;
          shortestMatch = matchLength;
        }
      }
    }
  });
  return active;
};

export const withActiveLink = (links, locationPathname, host, store) => {
  const activeLink = findActiveLink(links, locationPathname, host, store);
  const activeLinkIndex = links.findIndex(({ url }) => activeLink === url);
  if (activeLinkIndex > -1) {
    links[activeLinkIndex].active = true;
  }
  const matchActiveLink = links.find(({ url }) => activeLink === url);
  if (matchActiveLink) {
    matchActiveLink.active = true;
  }
  return links;
};
